import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, CheckIcon } from 'lucide-react';
import { CateringOffer, formatPrice } from '../data/smaken';
import { useRequest } from '../CartContext';
interface CateringCardProps {
  offer: CateringOffer;
  /** Hide the partner line when the card already sits on that partner's page. */
  showPlace?: boolean;
}
export function CateringCard({
  offer,
  showPlace = true
}: CateringCardProps) {
  const {
    add
  } = useRequest();
  const [added, setAdded] = useState(false);
  useEffect(() => {
    if (!added) return;
    const timer = window.setTimeout(() => setAdded(false), 1500);
    return () => window.clearTimeout(timer);
  }, [added]);
  return <article className="group flex h-full flex-col border-t-2 border-black pt-4" data-id="element-237" data-mp="d4ioll5gm4db">
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-black/5" data-id="element-238" data-mp="22jp5156yf4tt">
        <img src={offer.image} alt={offer.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-239" data-mp="27ia6f7xxzuju" />
        <span className="absolute left-0 top-0 bg-papper px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide2" data-id="element-240" data-mp="kw3ui42ta77k">
          {offer.category}
        </span>
      </div>

      <div className="flex flex-1 flex-col pt-4" data-id="element-241" data-mp="umgftyiga4er">
        {showPlace && <Link to={`/plats/${offer.placeSlug}`} className="text-[11px] font-bold uppercase tracking-wide2 text-rod transition-colors duration-150 ease-out hover:text-black" data-id="element-242" data-mp="upcghulon76w">
            {offer.placeName} · {offer.placeCity}
          </Link>}
        <h3 className="mt-2 font-display text-2xl leading-tight" data-id="element-243" data-mp="fvzfyjlgrmjz">{offer.name}</h3>
        <p className="mt-2 text-[0.95rem] leading-relaxed text-black/70" data-id="element-244" data-mp="axfv6milwgt7">{offer.description}</p>

        <p className="mt-3 text-[11px] font-semibold uppercase tracking-wide2 text-black/45" data-id="element-245" data-mp="1rbo2xaypwlks">
          {offer.occasions.join(' · ')}
        </p>
        <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide2 text-black/45" data-id="element-246" data-mp="k102tdmxudn5">
          Från {offer.minGuests} {offer.unit === 'per person' ? 'pers' : 'st'} · {offer.leadTime}{' '}
          {offer.leadTime === 1 ? 'dags' : 'dagars'} varsel
        </p>

        <div className="mt-auto flex items-end justify-between gap-4 pt-5" data-id="element-247" data-mp="szbqb6sicvbd">
          <p data-id="element-248" data-mp="xzzgxrctra52">
            <span className="font-display text-2xl" data-id="element-249" data-mp="xzpyqpy0u79x">{formatPrice(offer.price)}</span>
            <span className="ml-1.5 text-[11px] uppercase tracking-wide2 text-black/45" data-id="element-250" data-mp="1btjppi8fk0t">{offer.unit}</span>
          </p>
          <button onClick={() => {
          add(offer);
          setAdded(true);
        }} aria-label={`Lägg ${offer.name} i förfrågan`} className={`flex shrink-0 items-center gap-2 px-4 py-3 text-[11px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out ${added ? 'bg-skog text-papper' : 'bg-black text-papper hover:bg-rod'}`} data-id="element-251" data-mp="59r9oujtua59">
            {added ? <CheckIcon className="h-4 w-4" data-id="element-252" data-mp="3b665dd1yg0f5" /> : <PlusIcon className="h-4 w-4" data-id="element-253" data-mp="3b6fukyf6e3js" />}
            {added ? 'Tillagd' : 'Lägg till'}
          </button>
        </div>
      </div>
    </article>;
}